export interface Notification {
    body: string;
    click_action: string;
    icon: string;
    landing_page: string;
    title: string;
    topic: string;
  }
  